import React from 'react';
import { Link } from 'react-router-dom';
import './Cards.css';

const tourImages = {
  'atlas-mountains-day-trip':    ['https://www.image2url.com/r2/default/images/1776889060236-37d4350c-4b74-4ad9-a6f2-2eb4d3930966.jpg',   'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80'],
  'agafay-desert-day-trip':      ['https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=80', 'https://www.image2url.com/r2/default/images/1776889232025-fe77ba7a-b95e-4b38-9ab0-571163289526.jpg'],
  'ouzoud-waterfalls-trip':      ['https://www.image2url.com/r2/default/images/1776889330860-491f6402-d23c-4714-80b8-2b5485c43d64.jpg', 'https://images.unsplash.com/photo-1432405972618-c60b0225b8f9?w=600&q=80'],
  'ait-ben-haddou-kasbah':       ['https://images.unsplash.com/photo-1737927427538-9f9b4ea4ab02?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',   'https://images.unsplash.com/photo-1722166909028-d6cde685e080?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'essaouira-day-trip':          ['https://images.unsplash.com/photo-1624802704371-c76faa34c3a0?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://images.unsplash.com/photo-1565985482571-03a42ea59d80?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'ourika-valley-day-trip':      ['https://images.unsplash.com/photo-1671804079626-4aaafa95184e?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',   'https://images.unsplash.com/photo-1548448182-e619730025a9?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'marrakech-medina-guided-tour':['https://images.unsplash.com/photo-1597212618440-806262de4f6b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=600&q=80'],
  'marrakech-food-tour':         ['https://images.unsplash.com/photo-1643019237176-8ae0859f1123?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80'],
  'marrakech-casablanca-day-trip':['https://images.unsplash.com/photo-1701945247920-7e4a461e08cb?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=600&q=80'],
  'lake-takerkoust-asni-valley': ['https://www.image2url.com/r2/default/images/1776890677648-dad65ab7-ede1-4a42-8cb7-7b860349c01b.webp',   'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80'],
  'marrakech-photography-tour':  ['https://images.unsplash.com/photo-1554048612-b6a482bc67e5?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://images.unsplash.com/photo-1597212618440-806262de4f6b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'shopping-in-the-souks':       ['https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=600&q=80', 'https://images.unsplash.com/photo-1597212618440-806262de4f6b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'marrakech-agadir-day-trip':   ['https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80', 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80'],
};

const activityImages = {
  'hot-air-balloon-marrakech':           ['https://images.unsplash.com/photo-1549740425-5e9ed4d8cd34?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  'https://images.unsplash.com/photo-1533130061792-64b345e4a833?w=600&q=80'],
  'camel-ride-palmeraie':                ['https://images.unsplash.com/photo-1640328504956-e6fb38ff8934?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  'https://www.image2url.com/r2/default/images/1776891837449-a524d643-0894-43c3-8a92-ad0461183dc4.jpg'],
  'camel-ride-agafay':                   ['https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=80',  'https://images.unsplash.com/photo-1640328504956-e6fb38ff8934?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'quad-palmeraie':                      ['https://images.unsplash.com/photo-1627760444690-59f0a5fccee6?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  'https://www.image2url.com/r2/default/images/1776891837449-a524d643-0894-43c3-8a92-ad0461183dc4.jpg'],
  'quad-agafay':                         ['https://images.unsplash.com/photo-1624062999803-976e1adc8ea2?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=80'],
  'buggy-agafay':                        ['https://images.unsplash.com/photo-1635350644558-0f12a6a88cbd?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=80'],
  'horseback-riding-lake-takerkoust':    ['https://images.unsplash.com/photo-1633767979501-6225d151ba70?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',    'https://www.image2url.com/r2/default/images/1776890677648-dad65ab7-ede1-4a42-8cb7-7b860349c01b.webp'],
  'marrakech-cooking-class':             ['https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=600&q=80',  'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80'],
  'pottery-class-marrakech':             ['https://images.unsplash.com/photo-1612950662573-546117a61e78?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  'https://images.unsplash.com/photo-1609881583302-61548332039c?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'sidecar-tour-marrakech':              ['https://www.image2url.com/r2/default/images/1776895483967-ebd12bf7-9ca3-4d7a-b494-dc16d81b6024.webp',  'https://images.unsplash.com/photo-1597212618440-806262de4f6b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'marrakech-hammam-spa':                ['https://images.unsplash.com/photo-1714648775497-9f54f75eb3ea?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',    'https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?w=600&q=80'],
  'yoga-marrakech':                      ['https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80', 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80'],
};

const destImages = {
  'marrakech':      ['https://images.unsplash.com/photo-1670406071577-d795729196b4?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://images.unsplash.com/photo-1670406071577-d795729196b4?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'atlas-mountains':['https://www.image2url.com/r2/default/images/1776889060236-37d4350c-4b74-4ad9-a6f2-2eb4d3930966.jpg',   'https://www.image2url.com/r2/default/images/1776889060236-37d4350c-4b74-4ad9-a6f2-2eb4d3930966.jpg'],
  'agafay-desert':  ['https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=80', 'https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?w=800&q=80'],
  'essaouira':      ['https://images.unsplash.com/photo-1624802704371-c76faa34c3a0?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://images.unsplash.com/photo-1554254648-2d58a1bc3fd5?w=800&q=80'],
  'ouzoud':         ['https://www.image2url.com/r2/default/images/1776889330860-491f6402-d23c-4714-80b8-2b5485c43d64.jpg', 'https://images.unsplash.com/photo-1432405972618-c60b0225b8f9?w=800&q=80'],
  'ait-ben-haddou': ['https://images.unsplash.com/photo-1737927427538-9f9b4ea4ab02?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',   'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=800&q=80'],
  'ourika-valley':  ['https://images.unsplash.com/photo-1671804079626-4aaafa95184e?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',   'https://images.unsplash.com/photo-1523474438810-b04a2480633c?w=800&q=80'],
  'casablanca':     ['https://images.unsplash.com/photo-1701945247920-7e4a461e08cb?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',   'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=800&q=80'],
};

const blogImages = {
  'best-time-to-visit-morocco':          ['https://images.unsplash.com/photo-1670406071577-d795729196b4?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'agafay-desert-complete-guide':        ['https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=800&q=80'],
  'marrakech-medina-guide-first-timers': ['https://images.unsplash.com/photo-1597212618440-806262de4f6b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'what-to-pack-for-morocco':            ['https://www.image2url.com/r2/default/images/1776889060236-37d4350c-4b74-4ad9-a6f2-2eb4d3930966.jpg'],
  'moroccan-food-guide':                 ['https://images.unsplash.com/photo-1643019237176-8ae0859f1123?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
  'morocco-7-day-itinerary':             ['https://images.unsplash.com/photo-1737927427538-9f9b4ea4ab02?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'],
};

export function TourCard({ tour }) {
  const imgs = tourImages[tour.slug] || [];
  return (
    <Link to={`/tours/${tour.slug}`} className="card card--tour">
      {/* Main image */}
      <div className="card__bg">
        {imgs[0]
          ? <img src={imgs[0]} alt={tour.name} loading="lazy" />
          : <div style={{ width:'100%', height:'100%', background: `linear-gradient(135deg, ${tour.bgColor}, #1a1a2e)` }} />
        }
      </div>
      {/* Hover image */}
      {imgs[1] && (
        <div className="card__bg-hover">
          <img src={imgs[1]} alt={tour.name + ' view 2'} loading="lazy" />
        </div>
      )}
      <div className="card__overlay" />
      {tour.badge && <span className="badge badge-primary card__badge">{tour.badge}</span>}
      <div className="card__body">
        <div className="card__meta-top">
          <span className="card__cat">{tour.category === 'city-tours' ? 'City Tour' : 'Day Trip'}</span>
          <span className="card__rating">
            <span className="stars">★★★★★</span>
            <span className="card__rating-count">{tour.rating} ({tour.reviews})</span>
          </span>
        </div>
        <h3 className="card__title">{tour.name}</h3>
        <div className="card__info">
          <span>⏱ {tour.duration}</span>
          <span>👥 {tour.groupSize}</span>
        </div>
        <div className="card__tags">
          <span className="card__tag">{tour.difficulty}</span>
          <span className="card__tag">{tour.language[0]}</span>
        </div>
        <div className="card__cta-btn">Book Now</div>
      </div>
    </Link>
  );
}

export function ActivityCard({ activity }) {
  const imgs = activityImages[activity.slug] || [];
  return (
    <Link to={`/activities/${activity.slug}`} className="card card--activity">
      <div className="card__bg">
        {imgs[0]
          ? <img src={imgs[0]} alt={activity.name} loading="lazy" />
          : <div style={{ width:'100%', height:'100%', background: `linear-gradient(135deg, ${activity.bgColor}, #1a1a2e)` }} />
        }
      </div>
      {imgs[1] && (
        <div className="card__bg-hover">
          <img src={imgs[1]} alt={activity.name + ' view 2'} loading="lazy" />
        </div>
      )}
      <div className="card__overlay" />
      {activity.badge && <span className="badge badge-primary card__badge">{activity.badge}</span>}
      <div className="card__body">
        <div className="card__meta-top">
          <span className="card__cat">{activity.location}</span>
          <span className="card__rating">
            <span className="stars">★★★★★</span>
            <span className="card__rating-count">{activity.rating}</span>
          </span>
        </div>
        <h3 className="card__title">{activity.name}</h3>
        <div className="card__info">
          <span>⏱ {activity.duration}</span>
          {activity.minAge && <span>👤 Age {activity.minAge}+</span>}
        </div>
        <div className="card__tags">
          <span className="card__tag">{activity.fitnessLevel}</span>
          <span className="card__tag">{activity.location}</span>
        </div>
        <div className="card__cta-btn">Book Now</div>
      </div>
    </Link>
  );
}

export function DestinationCard({ destination }) {
  const imgs = destImages[destination.slug] || [];
  return (
    <Link to={`/destinations/${destination.slug}`} className="card card--destination">
      <div className="card__img-bg">
        {imgs[0]
          ? <img src={imgs[0]} alt={destination.name} loading="lazy" />
          : <div style={{ width:'100%', height:'100%', background: destination.bgColor }} />
        }
      </div>
      <div className="dest-card__overlay" />
      <div className="dest-card__body">
        <h3 className="dest-card__name">{destination.name}</h3>
        <p className="dest-card__tagline">{destination.tagline}</p>
        <div className="dest-card__counts">
          {destination.tourCount > 0 && <span>{destination.tourCount} tours</span>}
          {destination.activityCount > 0 && <span>{destination.activityCount} activities</span>}
        </div>
      </div>
    </Link>
  );
}

export function BlogCard({ post }) {
  const imgs = blogImages[post.slug] || [];
  return (
    <Link to={`/morocco-guide/${post.slug}`} className="card card--blog">
      <div className="card__img" style={{ position: 'relative' }}>
        {imgs[0]
          ? <img src={imgs[0]} alt={post.title} loading="lazy" />
          : <div style={{ width:'100%', height:'100%', background: `linear-gradient(135deg, ${post.bgColor}, #1a1a2e)` }} />
        }
        {imgs[1] && (
          <div className="card__bg-hover">
            <img src={imgs[1]} alt={post.title + ' 2'} loading="lazy" />
          </div>
        )}
      </div>
      <div className="card__body">
        <span className="card__cat">{post.categoryLabel}</span>
        <h3 className="card__title">{post.title}</h3>
        <p className="card__excerpt">{post.excerpt}</p>
        <div className="card__footer">
          <span className="card__date">{post.date}</span>
          <span className="card__cta">Read More →</span>
        </div>
      </div>
    </Link>
  );
}

export function ReviewCard({ review }) {
  return (
    <div className="review-card">
      <div className="review-card__stars">★★★★★</div>
      <p className="review-card__text">"{review.text}"</p>
      <div className="review-card__author">
        <span className="review-card__flag">{review.flag}</span>
        <div>
          <div className="review-card__name">{review.name}</div>
          <div className="review-card__tour">{review.tour}</div>
        </div>
      </div>
    </div>
  );
}
